import MaskedInput from 'react-text-mask/dist/reactTextMask';
import { emailMask } from 'text-mask-addons';
import { twMerge } from 'tailwind-merge';

const EmailField = ({ name, defaultValue, placeholder, onChange, className, ...properties }) => {
    return <MaskedInput name={name} mask={emailMask} onChange={onChange} className={twMerge(`text-black px-4 h-14 w-full bg-transparent border border-solid rounded-lg border-gray-200 focus:border-blue-900 focus:outline-none`, className)} {...properties} />;
};

export default EmailField;
